import type { DataErrorDetail } from '@/components/ui/data-error-banner';

/** Extract a structured DataErrorDetail from an unknown API error. */
export function captureApiError(err: unknown, endpoint: string): DataErrorDetail {
  if (err && typeof err === 'object' && 'code' in err && 'message' in err && 'status' in err) {
    const e = err as { code: string; message: string; status: number };
    return { endpoint, status: e.status, code: e.code, message: e.message };
  }
  return { endpoint, message: String(err), raw: String(err) };
}
